import { api_GET, api_POST, api_POSTFile } from "api/_axios.js";

const dadosimplantacaotim_api =
{
    getRegionais: function () {
        const promise = new Promise((resolve, reject) => {
            api_GET(`DadosImplantacaoTim/GetRegionais`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getGruposEconomicos: function (regional) {
        const promise = new Promise((resolve, reject) => {
            if (regional)
                api_GET(`DadosImplantacaoTim/GetGruposEconomicos/${regional}`).then(result => {
                    resolve(result)
                });
            else
                api_GET(`DadosImplantacaoTim/GetGruposEconomicos`).then(result => {
                    resolve(result)
                });
        });

        return promise;
    },

    getLojas: function (regional, grupoeconomico) {
        const promise = new Promise((resolve, reject) => {
            if (regional && grupoeconomico)
                api_GET(`DadosImplantacaoTim/GetLojas/${regional}/${encodeURIComponent(grupoeconomico)}`).then(result => {
                    resolve(result)
                });
            else
                api_GET(`DadosImplantacaoTim/GetLojas`).then(result => {
                    resolve(result)
                });
        });
        return promise;
    },

    getLojasByUsuarioGE: function (grupoeconomico) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`DadosImplantacaoTim/GetLojas/${encodeURIComponent(grupoeconomico)}`).then(result => {
                resolve(result)
            });
        });
        return promise;
    },


    getLojasbyGruposEconomicos: function (gruposeconomicos) {

        const promise = new Promise((resolve, reject) => {
            api_POST(`DadosImplantacaoTim/GetLojasbyGruposEconomicos`, gruposeconomicos).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    uploadCadTim: (arquivo) => {
        const formData = new FormData();
        formData.append("arquivo", arquivo);
        return api_POSTFile("DadosImplantacaoTim/UploadCadTIM", formData);
    },

    sincronizaCadTim: function () {
    const promise = new Promise((resolve, reject) => {
        api_POST(`DadosImplantacaoTim/SincronizaCadTim`).then(result => {
            resolve(result)
        });
    });

    return promise;
},
}

export default dadosimplantacaotim_api
